document.addEventListener('DOMContentLoaded', function () {
  const productForms = document.querySelectorAll('form[action^="/cart/add"]');

  productForms.forEach((form) => {
    form.addEventListener('submit', function (event) {
      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput || variantInput.value === '') {
        event.preventDefault();
        alert('Selecione uma opção antes de adicionar ao carrinho.');
        return;
      }

      const button = form.querySelector('button[type="submit"]');
      if (button) {
        button.setAttribute('disabled', true);
        button.classList.add('loading');
      }
    });
  });
});
